<div class="acct-page">
  <div class="av2-wrap guest">
    <section class="pane">
      <div class="pane-hd">
        <p class="eyebrow">Saved plates</p>
        <h1 class="stmt">Your shortlist.</h1>
        <p class="lead">Plates you've saved on this device. No account needed. Create a free account to keep them on every device.</p>
      </div>

      <div class="pcard" *ngFor="let reg of regs">
        <div class="pcard-main">
          <div class="pv">
            <span class="av2-plate plate-font md">{{ formatReg(reg) }}</span>
            <span class="cls">Saved</span>
          </div>
          <div class="mkt">
            <div class="al">Saved on this device</div>
          </div>
          <div class="acts">
            <a class="av2-btn av2-btn--green av2-btn--sm" [routerLink]="'/plates/' + reg">View plate</a>
            <ng-container *ngIf="confirmReg === reg; else ask">
              <button class="linkish neg" (click)="remove(reg)">Confirm removal?</button>
              <button class="linkish quietlink" (click)="confirmReg = null">Cancel</button>
            </ng-container>
            <ng-template #ask>
              <button class="linkish quietlink" (click)="confirmReg = reg">Remove</button>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="empty" *ngIf="regs.length === 0">
        <p>You haven't saved any plates yet. Tap the heart on any registration to keep it here.</p>
        <div class="starters">
          <a class="av2-btn av2-btn--ghost av2-btn--sm" routerLink="/plates">Search the register</a>
        </div>
      </div>
    </section>

    <aside class="join" aria-label="Free account">
      <p class="eyebrow">Free account</p>
      <h2 class="stmt">Never miss the right plate.</h2>
      <ul>
        <li><strong>Keep your shortlist</strong> on every device, not just this browser.</li>
        <li><strong>Track plates</strong> and hear when the price or availability changes.</li>
        <li><strong>Saved searches</strong> that tell you when new matching plates are listed.</li>
        <li><strong>Auction alerts</strong> when plates that suit you come up for sale.</li>
      </ul>
      <div class="join-acts">
        <button class="av2-btn av2-btn--green" (click)="join('register')">Create a free account</button>
        <button class="linkish quietlink" (click)="join('login')">I already have an account</button>
      </div>
      <p class="fine">Free, no card needed. Plates saved here move into your account when you sign in.</p>
    </aside>
  </div>
</div>
